/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */

/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';

import { N20, N800 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

/**
 * NOTE: This file is tech debt
 *
 * It used to be a `layout.tsx`, which has been replaced by `src/components/layout.tsx`. However,
 * annoyingly this file exported some shared styles used by `pages/404.tsx`, `pages/index.tsx`, and
 * `templates/page.tsx`, so these styles have been left here so they aren't duplicated.
 *
 * Ideally it should be replaced by components like `<MainContent>` and `<CollapsibleGutterContainer>`.
 * However, since the site is currently being rebuilt, so investments in tech debt are probably not worth out time.
 *
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const mainContentStyles = css({
	display: 'grid',
	/* We absolutely position child tabs. */
	position: 'relative',
	gap: token('space.200', '16px'),
	gridAutoRows: 'max-content',
	gridTemplateColumns: 'repeat(12, 1fr)',
	gridArea: 'content',
	marginBlockStart: token('space.0', '0px'),
	paddingBlockEnd: token('space.500', '40px'),
	paddingBlockStart: token('space.400', '32px'),
	'> *': {
		gridColumn: '1 / span 12',
		marginBlockEnd: token('space.0', '0px'),
		marginBlockStart: token('space.0', '0px'),
	},
	'.brisk-table': {
		thead: {
			tr: {
				/* Hack to work around pretty prop types heading not being bold atm. */
				fontWeight: token('font.weight.medium', '500'),
			},
		},
		td: {
			verticalAlign: 'top',
		},
		'td > code': {
			padding: token('space.050', '4px'),
			backgroundColor: token('color.background.neutral', N20),
			borderRadius: token('border.radius', '3px'),
			color: token('color.text', N800),
		},
		'td > div': {
			/* Hack to remove margin from ERT div. */
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
			margin: `${token('space.0', '0px')} !important`,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
		'td:not(:last-child)': {
			paddingInlineEnd: token('space.100', '8px'),
		},
	},
});
